import { TranslateService } from '@ngx-translate/core';
import { Alert, AlertUser, EventAlertEntity, PriorityConfig } from '../../models/alert';
import { EventAlertViewModel } from './event-alert.view-model';

export class TeacherDeclinedAlertViewModel extends EventAlertViewModel {
  constructor(
    alert: Alert<EventAlertEntity>,
    translateService: TranslateService,
    priorityConfig: PriorityConfig | null = null,
  ) {
    super(alert, translateService, priorityConfig);
  }

  get title(): string {
    return `${this.translateService.instant('Declined event')}: ${
      (this.triggeredBy as AlertUser)?.name
    }`;
  }

  override get expiryDate(): Date | null {
    return this.entity?.start_time ?? null; // mapped dynamically to the event
  }

  override get alertTypeLabel(): string {
    const triggerId = (this.triggeredBy as AlertUser)?._id;
    const isHost = this.entity?.host_ids?.some((host) => host?._id === triggerId);

    return isHost
      ? this.translateService.instant('Decline event: Organizer')
      : this.translateService.instant('Decline event: Attendee');
  }
}
